import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { SimpleForm, useEditController, useNotify } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import { CancelButton, SaveButtonValidated, DeleteButton } from 'shared/mui/Buttons';
import { CardActionsButtons } from 'shared/mui/Card';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { EditPage } from 'shared/react-admin/Pages/EditPage/EditPage';
import { Permission } from 'types/embedded/permission';
import { ProviderAccount } from 'types/embedded/providerAccount';
import { getId } from 'utils';

import { ProviderAccountsEditForm } from './ProviderAccountsEditForm';

export const ProviderAccountsEdit: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();
  const { record } = useEditController<ProviderAccount>();
  const navigate = useNavigate();
  const notify = useNotify();

  const transform = (data: ProviderAccount) =>
    record?.workTeam === data.workTeam ? data : { ...data, members: [] };

  const {
    record: providerAccount,
    handleCloseRecordModal,
    openRecordModal,
    handleOpenRecordModal,
  } = useRecordModal<ProviderAccount>();

  async function onError(error: any) {
    notify(error.message, { type: 'error' });
  }

  return (
    <>
      <EditPage
        listName="Настройки доступа"
        mutationMode="pessimistic"
        mutationOptions={{ onError }}
        title="Редактирование настройки доступа"
        transform={transform}
      >
        <SimpleForm sx={{ '&.MuiCardContent-root': { padding: 0 } }} toolbar={false}>
          <ProviderAccountsEditForm />
          <CardActionsButtons
            leftActionsSlot={
              hasResourcePermissions(Resources.ProviderAccounts, [
                Permission.Full,
                Permission.Delete,
              ]) && (
                <DeleteButton onClick={() => handleOpenRecordModal(record)} variant="outlined" />
              )
            }
            rightActionsSlot={[
              <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
              <SaveButtonValidated key="save-button" label="Сохранить" />,
            ]}
            sx={{ marginTop: 'auto', padding: 0 }}
          />
        </SimpleForm>
      </EditPage>
      <DeleteDialog
        details={`Настройка доступа ID ${getId(record?.id)} будет удалена без возможности восстановления.`}
        onClose={handleCloseRecordModal}
        onSuccess={() => navigate(-1)}
        open={openRecordModal}
        record={providerAccount}
        title="Удаление настройки доступа"
      />
    </>
  );
};
